import { Component } from '@angular/core';
import { FilterUIModel } from '../Filters/filterUI.model';
import { AgGridFloatingFilterBase, WSFloatingFilterParams } from './agGridFloatingFilterBase';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'number-floating-filter-component',
    template: `@if (!(type === 'blank' || type === 'notBlank')) {
            <input
                type="text"
                [numbersOnly]="true"
                class="ag-floating-filter-input"
                data-show-value="true"
                data-popup-enabled="true"
                [readOnly]="conditionApplied"
                [(ngModel)]="value"
                (keyup.enter)="enterPressed($event)"
                (ngModelChange)="valueChange(false)"
            />
        }
        @if (type === 'blank' || type === 'notBlank') {
            <div>
                <span class="reset-value clickable" (click)="clearFilter()">
                    <i class="fa fa-times"></i>
                </span>
                <span>{{ type === 'blank' ? 'Blank' : 'Not Blank' }}</span>
            </div>
        } `,
    styleUrls: ['./agGridFloatingFilter.scss'],
    host: { class: 'ag-input-wrapper' },
    standalone: false,
})
export class AgGridNumberFloatingFilterComponent extends AgGridFloatingFilterBase<WSFloatingFilterParams> {
    constructor(private toastr: ToastrService) {
        super();
    }

    onParentModelChanged(parentModel: FilterUIModel): void {
        const model = (parentModel as any)?._wsFilter ?? parentModel;
        this.value = '';
        this.type = this._params.filterParams['defaultOption'];
        if (model && (model.filterConditionType || (model.filterValues[0] && model.filterValues[0].filterToValue))) {
            this.value = model.filterValues
                .map((x) =>
                    x.filterType.displayKey === 'blank' || x.filterType.displayKey === 'notBlank'
                        ? `${x.filterType.displayName}`
                        : `${x.filterType.displayName} "${x.filterValue}"${x.filterToValue ? ` - "${x.filterToValue}"` : ''}`,
                )
                .join(model.filterConditionType === Core.FilterConditionTypeEnum.And ? ' AND ' : ' OR ');
            this.conditionApplied = true;
        } else {
            this.value = model && model.filterValues[0] && model.filterValues[0].filterValue;
            this.type = model && model.filterValues[0] && model.filterValues[0].filterType.displayKey;
            this.conditionApplied = false;
        }
    }

    enterPressed(event: Event): void {
        if (this.value === '-') {
            this.toastr.error('Please enter a valid negative value');
            event.stopPropagation();
        }
    }
}
